angular.module('account.roles', [
    'account.roles.index',
    'account.roles.add',
    'account.roles.edit'
  ]);
  


// WEBPACK FOOTER //
// ./client/src/app/account/roles/index.js